import React, { useState, useCallback } from 'react';
import RoomCategoryListComponent from '../ManageRoom/RoomCategoryListComponent';
import Loader from '../Common/Loader';

const RoomCategoryListContainer = (props) => {
  const [notice, setNotice] = useState({ type: '', message: '' });
  const [loaderStatus, setLoaderStatus] = useState(false);

  const setNoticeMessage = useCallback((errorMessage, errorType) => {
    setNotice({ type: errorType, message: errorMessage });
    setTimeout(() => {
      setNotice({ type: '', message: '' });
    }, 3000);
  }, []);

  const setUILoaderVisibility = useCallback((status) => {
    setLoaderStatus(status);
  }, []);

  return (
    <React.Fragment>
      {loaderStatus ? <Loader /> : null}
      <div
        className={`alert_col posfixed pad10 tc fnt16 bld ${
          notice.type === 'error' ? 'danger' : 'success'
        } ${notice.message === '' ? 'hides' : ''}`}
      >
        {notice.message}
      </div>
      <RoomCategoryListComponent
        history={props.history}
        setNoticeMessage={setNoticeMessage}
        setUILoaderVisibility={setUILoaderVisibility}
      />
    </React.Fragment>
  );
};

export default RoomCategoryListContainer;
